import React from "react";

import {Context} from "@reactivated";
import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { Toaster } from "@client/shadcn/ui/sonner";

interface Props {
    title: string;
    children: React.ReactNode;
    className?: string;
}

export const Layout = (props: Props) => {
    const context = React.useContext(Context);

    return (
        <html>
            <head>
                <meta charSet="utf-8" />
                <title>{props.title}</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link
                    rel="icon"
                    href={`${context.STATIC_URL}favicon.ico`}
                    type="image/x-icon"
                />
            </head>
            <body className="dark">
                <main>
                    <NavBar />
                    {props.children}
                    <Footer />
                </main>
                <Toaster />
            </body>
        </html>
    );
};
